import { useMessage } from 'naive-ui'

const MessageContent = () => {
  const message = useMessage()

  window.$message = message

  return <></>
}

export default MessageContent
